import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

export function ServiceFeeOverview() {
  const navigate = useNavigate();

  useEffect(() => {
    // Simple fade-in animation for elements
    const animateElements = () => {
      const elements = document.querySelectorAll('.animate-fade-in');
      elements.forEach((el, index) => {
        setTimeout(() => {
          el.classList.add('opacity-100');
          el.classList.remove('opacity-0', 'translate-y-4');
        }, 300 * index);
      });
    };
    
    animateElements();
  }, []);

  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-teal-50 to-green-50 py-16 md:py-24 px-4 md:px-6 text-center">
      {/* Decorative SVG pattern - left side */}
      <div className="absolute left-0 top-0 h-full w-1/3 opacity-10 pointer-events-none">
        <svg viewBox="0 0 200 800" xmlns="http://www.w3.org/2000/svg">
          <path 
            fill="#22d3ee" 
            d="M40,13.9C34.3,27.8,-38,45.5,-47.4,31.8C-56.8,18.1,-3.2,-27,16.3,-27.3C35.8,-27.7,45.7,0,40,13.9Z" 
            transform="translate(100 100)" 
          />
          <path 
            fill="#84cc16" 
            d="M40,21.9C29.1,36.6,-15.5,33.1,-33.2,13.9C-50.9,-5.4,-41.7,-40.4,-20.8,-52.9C0.1,-65.5,32.7,-55.5,47.8,-37.5C62.9,-19.5,50.9,7.3,40,21.9Z" 
            transform="translate(100 300)" 
          />
          <path 
            fill="#22d3ee" 
            d="M25.3,34.5C-1.1,41.9,-39.3,33.2,-51.4,8.8C-63.5,-15.6,-49.5,-55.8,-25.4,-63.4C-1.3,-71.1,32.9,-46.2,48.4,-18.6C63.9,9,51.7,27.1,25.3,34.5Z" 
            transform="translate(100 500)" 
          />
          <path 
            fill="#84cc16" 
            d="M31.9,35.1C14.9,44.6,-18.3,43.2,-36.7,26.3C-55.1,9.3,-58.6,-23.2,-45.5,-39.1C-32.3,-55,-2.5,-54.2,17.1,-44.4C36.8,-34.6,46.3,-15.9,48.9,5.4C51.5,26.7,48.9,25.7,31.9,35.1Z" 
            transform="translate(100 700)" 
          />
        </svg>
      </div>
      
      {/* Decorative SVG pattern - right side */}
      <div className="absolute right-0 top-0 h-full w-1/3 opacity-10 pointer-events-none">
        <svg viewBox="0 0 200 800" xmlns="http://www.w3.org/2000/svg">
          <path 
            fill="#84cc16" 
            d="M47.8,27.3C42.6,45.3,21.3,45.2,0.5,44.6C-20.2,44,-40.5,42.9,-47.7,30.1C-54.9,17.4,-49.1,-7,-37.8,-23.4C-26.5,-39.9,-9.8,-48.4,10.9,-49.5C31.6,-50.6,56.3,-44.3,64.2,-29.3C72.1,-14.2,53,9.3,47.8,27.3Z" 
            transform="translate(100 100)" 
          />
          <path 
            fill="#22d3ee" 
            d="M35.6,39.3C17.1,50.2,-13.6,43.7,-32.9,24.7C-52.3,5.8,-60.4,-25.6,-49.7,-43.2C-39,-60.7,-9.5,-64.4,14.8,-59.1C39,-53.7,58,-39.3,65.5,-20.8C73,-2.2,54.1,28.4,35.6,39.3Z" 
            transform="translate(100 300)" 
          />
          <path 
            fill="#84cc16" 
            d="M31.3,36.9C7.8,43.5,-21.3,32.8,-35.6,12.3C-49.9,-8.2,-49.4,-38.4,-33.8,-51.8C-18.2,-65.2,12.6,-61.7,32.9,-47.5C53.3,-33.3,63.3,-8.3,56.8,12C50.3,32.3,54.9,30.3,31.3,36.9Z" 
            transform="translate(100 500)" 
          />
          <path 
            fill="#22d3ee" 
            d="M50.5,50.5C32.1,60.9,11.6,59,-2.3,51.9C-16.3,44.9,-23.7,32.7,-36.8,15.6C-49.9,-1.5,-68.8,-23.6,-66.2,-40.1C-63.7,-56.7,-39.8,-67.7,-17.9,-67.3C4,-66.9,23.8,-55.1,37.9,-40.3C52,-25.5,60.3,-7.7,64.4,13.1C68.5,33.9,68.9,40.1,50.5,50.5Z" 
            transform="translate(100 700)" 
          />
        </svg>
      </div>
      
      <div className="max-w-4xl mx-auto space-y-8 relative z-10">
        <div className="animate-fade-in opacity-0 translate-y-4 transition-all duration-700 ease-out">
          <h1 className="text-4xl sm:text-5xl font-extrabold bg-gradient-to-r from-teal-600 to-green-600 bg-clip-text text-transparent">
            Personalized Care, Transparent Fees
          </h1>
        </div>
        
        <div className="animate-fade-in opacity-0 translate-y-4 transition-all duration-700 ease-out delay-300">
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            We offer high-quality dental care tailored to your needs—without insurance restrictions. Every smile is unique, and your treatment should be too.
          </p>
        </div>
        
        {/* <div className="animate-fade-in opacity-0 translate-y-4 transition-all duration-700 ease-out delay-600 pt-4">
          <button onClick={() => navigate('/fee-schedule')} 
            className="cursor-pointer bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-medium py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            View Our Fee Schedule
          </button>
        </div> */}
      </div>
      
      {/* Tooth-inspired decoration at bottom */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-md opacity-10 pointer-events-none">
        <svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
          <path 
            fill="#22d3ee" 
            d="M44.7,6.2C52.3,21.1,48.3,47.5,32.5,58.9C16.6,70.3,-11.1,66.7,-28.8,53.1C-46.5,39.4,-54.1,15.7,-47.4,0.3C-40.7,-15.2,-19.9,-22.4,0.7,-22.7C21.3,-23,37.1,-8.8,44.7,6.2Z" 
            transform="translate(100 50)" 
          />
        </svg>
      </div>
    </section>
  );
}

export default ServiceFeeOverview;